import React, { FC } from 'react'

import { Txt, FontSizeType } from 'src/components/atoms'

import { ProjectStatusType } from 'src/types'

type Props = {
  status: ProjectStatusType
  sizeType?: FontSizeType
  className?: string
}

export const ProjectStatusTxt: FC<Props> = ({ status, sizeType, className }) => {
  return (
    <div className={className}>
      <Txt
        sizeType={sizeType}
        className={
          status.name === 'active'
            ? 'tw-text-pattern6-2'
            : status.name === 'preparing'
            ? 'tw-text-pattern6-3'
            : status.name === 'stopped'
            ? 'tw-text-pattern6-4'
            : 'tw-text-pattern6-5'
        }
      >
        {status.displayName}
      </Txt>
    </div>
  )
}
